import { render, staticRenderFns } from "./BirthdayTemplateAdd.vue?vue&type=template&id=0505235b&scoped=true&"
import script from "./BirthdayTemplateAdd.vue?vue&type=script&lang=js&"
export * from "./BirthdayTemplateAdd.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayTemplateAdd.vue?vue&type=style&index=0&id=0505235b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0505235b",
  null
  
)

export default component.exports